/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Local_StorageInputs */

const en_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Local Storage`)
};

const fr_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le stockage local`)
};

const de_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalen Speicher verwenden`)
};

const it_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizza l'archiviazione locale`)
};

const ru_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать локальное хранилище`)
};

const es_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar almacenamiento local`)
};

const zh_cn2_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用本地存储`)
};

const ja_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルストレージを使用する`)
};

const hi_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय संग्रहण का उपयोग करें`)
};

const pt_pt2_use_local_storage = /** @type {(inputs: Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar armazenamento local`)
};

/**
* | output |
* | --- |
* | "Use Local Storage" |
*
* @param {Use_Local_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const use_local_storage = /** @type {((inputs?: Use_Local_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Local_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_use_local_storage(inputs)
	if (locale === "de") return de_use_local_storage(inputs)
	if (locale === "it") return it_use_local_storage(inputs)
	if (locale === "ru") return ru_use_local_storage(inputs)
	if (locale === "es") return es_use_local_storage(inputs)
	if (locale === "zh-CN") return zh_cn2_use_local_storage(inputs)
	if (locale === "ja") return ja_use_local_storage(inputs)
	if (locale === "hi") return hi_use_local_storage(inputs)
	if (locale === "pt-PT") return pt_pt2_use_local_storage(inputs)
	return en_use_local_storage(inputs)
});